import type { RegisterOptions } from 'react-hook-form';

/**
 * Паттерны разрешенных символов для полей ввода
 */
export const ALLOWED_CHARS_PATTERNS = {
  name: /[А-ЯЁа-яёA-Za-z\s\-]/,
  phone: /[\d\s\-\+\(\)]/,
} as const;

/**
 * Правила валидации для формы оформления заказа
 */
export const CHECKOUT_VALIDATION: Record<string, RegisterOptions> = {
  firstName: {
    required: 'Обязательное поле',
    minLength: { value: 2, message: 'Минимум 2 символа' },
    maxLength: { value: 50, message: 'Максимум 50 символов' },
    pattern: {
      value: /^[А-ЯЁа-яёA-Za-z\s\-]+$/,
      message: 'Только буквы, пробелы и дефис',
    },
    validate: {
      noOnlySpaces: (value: string) =>
        value.trim().length > 0 || 'Поле не может состоять только из пробелов',
      noNumbers: (value: string) => !/\d/.test(value) || 'Имя не может содержать цифры',
      noSpecialChars: (value: string) =>
        !/[!@#$%^&*()_+={}[\]:;"'<>,.?/\\|`~]/.test(value) || 'Недопустимые символы',
    },
    setValueAs: (value: string) => value.trim(),
  },
  lastName: {
    required: 'Обязательное поле',
    minLength: { value: 2, message: 'Минимум 2 символа' },
    maxLength: { value: 50, message: 'Максимум 50 символов' },
    pattern: {
      value: /^[А-ЯЁа-яёA-Za-z\s\-]+$/,
      message: 'Только буквы, пробелы и дефис',
    },
    validate: {
      noOnlySpaces: (value: string) =>
        value.trim().length > 0 || 'Поле не может состоять только из пробелов',
      noNumbers: (value: string) => !/\d/.test(value) || 'Фамилия не может содержать цифры',
      noSpecialChars: (value: string) =>
        !/[!@#$%^&*()_+={}[\]:;"'<>,.?/\\|`~]/.test(value) || 'Недопустимые символы',
    },
    setValueAs: (value: string) => value.trim(),
  },
  phone: {
    required: 'Обязательное поле',
    pattern: {
      value: /^[\d\s\-\+\(\)]+$/,
      message: 'Разрешены только цифры, +, пробелы, дефисы и скобки',
    },
    validate: {
      minDigits: (value: string) => {
        const digits = value.replace(/\D/g, '');
        return digits.length >= 7 || 'Минимум 7 цифр';
      },
      maxDigits: (value: string) => {
        const digits = value.replace(/\D/g, '');
        return digits.length <= 15 || 'Максимум 15 цифр';
      },
      notAllSame: (value: string) => {
        const digits = value.replace(/\D/g, '');
        return digits.length < 7 || !/^(\d)\1+$/.test(digits) || 'Некорректный номер';
      },
    },
    setValueAs: (value: string) => value.replace(/[^\d+]/g, ''),
  },
  email: {
    required: 'Обязательное поле',
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Некорректный формат email',
    },
  },
};
